import { GlobalFormats } from '../../classess/main/globalFormats';
import { getLanguageObj, settings } from '../../helpers/main';

export default function Footer({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: 'Footer' })?.result),
}) {
    return (
        <footer className='main-footer border-top-0 bg-white text-sm shadow-sm p-3'>
            <div className='container-fluid'>
                <div className='row align-items-center'>
                    <div className='col-12 col-md-6 text-center text-md-left mb-2 mb-md-0'>
                        <span className='text-muted'>
                            <strong>Copyright &copy; {settings.app.copyRight} <a href={settings.supplier.url} target='_blank' rel='noreferrer' className='text-primary font-weight-bold'>{settings.supplier.name}</a></strong>
                            {' '} {settings?.labels?.allRightsReserved?.[languageObj?.id] || 'All rights reserved.'}
                        </span>
                    </div>
                    <div className='col-12 col-md-6 text-center text-md-right'>
                        <span className='text-muted'>
                            <b className='text-dark'>{settings?.labels?.version?.[languageObj?.id] || 'Version'}</b> {settings.app.version}
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}